// src/api/teamApi.js
import axiosClient from "./axiosClient";

export const getTeams = async (organizationId) => {
  const response = await axiosClient.get("/team", {
    params: {
      organizationId,
    },
  });

  return response.data;
};

export const addTeam = async ({ name, organizationId }) => {
  const response = await axiosClient.post("/team", {
    name,
    organizationId,
  });

  return response.data;
};

// Adds a team to an existing organization, with its own join code.
// Returns { teamId, code }.
export const addTeamWithJoinCode = async ({ name, organizationId }) => {
  const response = await axiosClient.post("/team/withjoincode", {
    name,
    organizationId,
  });

  return response.data;
};
